import { useEffect, useState } from 'react';

const RED = 'oklch(0.63 0.20 25)';

export function NowLine({
  startHour,
  endHour,
  hourH,
}: {
  startHour: number;
  endHour: number;
  hourH: number;
}) {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 30_000);
    return () => clearInterval(id);
  }, []);

  const hours = now.getHours() + now.getMinutes() / 60 + now.getSeconds() / 3600;
  if (hours < startHour || hours > endHour) return null;
  const top = (hours - startHour) * hourH;

  return (
    <div className="absolute left-0 right-0 pointer-events-none z-[25]" style={{ top }} aria-hidden>
      <div style={{ position: 'absolute', left: 0, right: 0, top: -1, height: 2, background: RED }} />
      <div
        style={{
          position: 'absolute',
          left: -4,
          top: -5,
          width: 10,
          height: 10,
          borderRadius: '9999px',
          background: RED,
        }}
      />
    </div>
  );
}
